import type { ParsedLocation } from '@tanstack/react-router';
import type { RouterContext } from '../../routes/__root';
import type { RedirectPolicyContext } from './redirectPolicy';

const getSearchValue = (search: ParsedLocation['search'], key: 'description' | 'promo') => {
  const value = (search as GenericRecord)[key];
  return typeof value === 'string' ? value : undefined;
};

export const getRedirectContext = ({
  context,
  location,
}: {
  context: RouterContext;
  location: ParsedLocation;
}): RedirectPolicyContext => ({
  description: getSearchValue(location.search, 'description'),
  href: location.href,
  isAuthenticated: Boolean(context.authentication?.isAuthenticated),
  isClientLoading: Boolean(context.redirectContext?.isClientLoading),
  isClientStatusLoading: Boolean(context.redirectContext?.isClientStatusLoading),
  isGrowthbookReady: Boolean(context.redirectContext?.isGrowthbookReady),
  isSignupChangesEnabled: Boolean(context.redirectContext?.isSignupChangesEnabled),
  membershipComplete: Boolean(context.redirectContext?.membershipComplete),
  onboardingComplete: Boolean(context.redirectContext?.onboardingComplete),
  pathname: location.pathname,
  profileComplete: Boolean(context.redirectContext?.profileComplete),
  promo: getSearchValue(location.search, 'promo'),
});
